import React, { Component } from 'react';
import { Text, View, Platform, StyleSheet } from 'react-native';

import NavBar from '../../navbar';
import Navigation from '../../navigation';
import SuggestionList from './suggestion_list';
import OPComponent from '../components/op_component';
import DivWebOnly from '../components/div_web_only';
import Container from './container';
import { THEME, __WEB__, COLOR, FONT } from '../../constants/styles';
import { CTAButton } from '.';
import I18n from '../../I18n';

export default class GenericSuggestionListModal extends OPComponent {
  static navigatorStyle = NavBar && NavBar.navigatorStyle;
  constructor(props) {
    super(props);
    this._value = props.defaultValue;
  }

  navigationButtonPressed = ({ buttonId }) => {
    const { componentId } = this.props;

    if (
      NavBar.handleButtonPress(componentId, buttonId, {
        onSave: this.save,
      })
    )
      return;
  };
  componentDidMount() {
    Navigation.registerForButtonEvents(this);
    Navigation.setButtons(
      {
        rightButtons: !this.props.restrictToListValues ? [NavBar.buttons.save] : [],
        leftButtons: [NavBar.buttons.cancel],
      },
      this.props.componentId
    );
  }
  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
  }

  save = () => {
    this.props.onValue && this.props.onValue(this._value, this._item);
    Navigation.close(this.props);
  };

  setValue = ({ value, item }) => {
    this._value = value;
    this._item = item;
    if (item && this.props.closeOnSelect) {
      this.save();
    }
  };

  renderItem = (item) => {
    return (
      <DivWebOnly className="op-secondary-btn-no-border">
        <View style={styles.itemContainer}>
          <Text style={styles.itemText}>{item.label}</Text>
        </View>
      </DivWebOnly>
    );
  };

  handleCancel = () => {
    Navigation.dismissModal(this.props.componentId);
  };

  render() {
    return (
      <Container style={[styles.container]}>
        <View style={styles.innerContainerStyle}>
          <View style={{ flex: 1 }}>
            <SuggestionList
              items={this.props.items}
              defaultValue={this.props.defaultValue}
              onValue={this.setValue}
              placeholderText={this.props.placeholderText}
              innerContainerStyle={
                __WEB__ ? { borderRadius: 10, backgroundColor: 'rgb(241, 241, 241)' } : null
              }
              inputContainerStyle={
                __WEB__
                  ? {
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                      borderBottomWidth: 1,
                      borderColor: 'rgb(208, 209, 212)',
                    }
                  : null
              }
              containerStyle={{ flex: 1 }}
              renderItem={this.renderItem}
              itemSeparatorComp={<View style={{ height: 0 }} />}
              closeOnSelect={this.props.closeOnSelect}
            />
          </View>
          {!!__WEB__ && (
            <CTAButton
              style={{
                borderRadius: 10,
                backgroundColor: 'rgb(241, 241, 241)',
                marginTop: 6,
                height: 50,
              }}
              styleType="secondary"
              fontStyle={styles.itemText}
              onPress={this.handleCancel}
              label={I18n.t('cancel')}
            />
          )}
        </View>
      </Container>
    );
  }
}

const styles = StyleSheet.create({
  container: __WEB__
    ? {
        flex: 1,
        backgroundColor: COLOR.overlay,
        paddingTop: 60,
      }
    : {
        ...THEME.containerAlt,
      },
  innerContainerStyle: __WEB__
    ? {
        flex: 1,
        backgroundColor: 'transparent',
        paddingHorizontal: 20,
        borderRadius: 10,
        overflow: 'hidden',
        paddingBottom: 20,
      }
    : {
        flex: 1,
        backgroundColor: 'transparent',
        overflow: 'hidden',
        paddingBottom: 40,
      },
  itemContainer: {
    padding: 10,
    borderBottomWidth: 1,
    borderBottomColor: 'rgb(208, 209, 212)',
    backgroundColor: 'rgb(241, 241, 241)',
    // alignItems: 'center',
    paddingVertical: 15,
    paddingLeft: 25,
  },
  itemText: {
    ...THEME.textSemibold,
    ...THEME.linkStyle,
    fontSize: 16,
    color: 'rgb(55, 122, 241)',
    // textAlign: 'center'
  },
});
